import styled from "styled-components";

const Imprint = () => {
  return (
    <ImprintsContainer>
      <div className="ImprintsContent">

        <div className="ImprintsLeftText">
            <h1>Imprint</h1>
        </div>

        <div className="ImprintsInfo">

            <div className="ImprintsSection">
                <h4>Angaben gemäß § 5 TMG</h4>
                <p>
                    Yasmin Ahmed
                    <br></br>
                    Yasmin Ahmed Consulting
                    <br></br>
                    Christoph-Rapparini-Bogen 5
                    <br></br>
                    80639 München
                </p>
            </div>

            <div className="ImprintsSection">
                <h4>Kontakt:</h4>
                <p>
                    Telefon: +491737034810
                    <br></br>
                    E-Mail: contact@yasminahmed.com
                </p>
            </div>

            <div className="ImprintsSection">
                <h4>Umsatzsteuer-ID:</h4>
                <p>
                    Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE359231507
                </p>
            </div>

            <div className="ImprintsSection">
                <h4>Redaktionell verantwortlich:</h4>
                <p>
                    Yasmin Ahmed
                    <br></br>
                    Christoph-Rapparini-Bogen 5
                    <br></br>
                    80639 München
                </p>
            </div>

            <div className="ImprintsSection">
                <h4>EU-Streit&shy;schlichtung:</h4>
                <p>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a rel="noreferrer" href="https://ec.europa.eu/consumers/odr/" target="_blank">https://ec.europa.eu/consumers/odr/</a>
                    <br></br>
                    Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </p>
            </div>

            <div className="ImprintsSection">
                <h4 className="manualBreak">Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle:</h4>
                <p>
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
                </p>
            </div>

            <div className="ImprintsSection">
                <h4>Haftung für Inhalte:</h4>
                <p>
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den.
                    <br></br>
                    allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
                    <br></br>
                    verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
                    <br></br>
                    forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                    <br></br>
                    Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
                    <br></br>
                    Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
                    <br></br>
                    Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
                    <br></br>
                    Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                </p>
            </div>

            <div className="ImprintsSection">
                <h4>Haftung für Links:</h4>
                <p>                
                    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                    <br></br>
                    Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>
            </div>

            <div className="ImprintsSection">
                <h4>Urheberrecht:</h4>
                <p>
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                    <br></br>
                    Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                </p>
            </div>

            <div className="ImprintsSection">
                <h4>Quelle:</h4>
                <p>
                    <a rel="noreferrer" href="https://www.e-recht24.de/impressum-generator.html" target="_blank">https://www.e-recht24.de/impressum-generator.html</a>
                </p>
            </div>
        </div>


      </div>
    </ImprintsContainer>
  );
}

const ImprintsContainer = styled.div`
animation: 1s ease-out 0s 1 slideInFromLeft;
width: 100%;
height: 100%;

/* background-color: rgba(250, 249, 246, 1); */
background-color: white;
overflow: hidden;

color: rgba(0,0,0,0.9);
font-family: 'Montserrat', sans-serif;

.ImprintsContent {
    width: 100%;
    height: 100%;
    padding-left: 10%;
    padding-right: 10%;

    display: flex;
    @media (max-width: 900px) {
        padding-left: 1%;
        padding-right: 1%;
        flex-direction: column;
        overflow-x: hidden;
        overflow-y: scroll;
    }
    @media (min-width: 900px) {
        justify-content: center;
        align-items: center;
    }

    .ImprintsLeftText {
        @media (min-width: 900px) {
            flex: 1 1 0;
        }
        
        height: 100%;
        width: 100%;

        display: flex;
        justify-content: center;
        padding-top: 120px;
        @media (max-width: 900px) {
            align-items: center;
            padding-top: 0px;
            height: 60px;
        }

        h1 {
            font-size: 50px;
            font-weight: 500;
            letter-spacing: 1px;
            /* line-height: 100px; */
            @media (max-width: 900px) {
                font-size: 38px;
            }
        }
    }
    .ImprintsInfo {
        @media (min-width: 900px) {
            flex: 1.5 1.5 0;
            
            overflow-x: hidden;
            overflow-y: scroll;
        }
        
        height: 100%;
        width: 100%;


        display: flex;
        flex-direction: column;

        .manualBreak {
            hyphens: manual;
        }

        .ImprintsSection {
            hyphens: auto;
            flex: 1 1 0;
            width: 100%;
            height: 100%;

            padding-top: 20px;
            padding-bottom: 20px;
            padding-left: 15%;
            padding-right: 15%;

            @media (max-width: 900px) {
                padding-top: 10px;
                padding-bottom: 10px;
                padding-left: 3%;
                padding-right: 3%;
            }

            h4 {
                font-weight: 500;
                font-size: 25px;
                letter-spacing: 2px;
                line-height: 40px;

                overflow-wrap: break-word;
                text-align: start;
                text-justify: inter-word;
                word-wrap: break-all;
                /* width: fit-content; */
            }
            
            @media (max-width: 900px) {
                h4 {
                    font-size: 17px;
                    font-weight: 600;
                }
            }
            p {
                text-align: start;
                text-justify: inter-word;
                word-wrap: break-all;
                overflow-wrap: break-word;
                font-size: 14px;
                letter-spacing: 1px;
                font-weight: 100;
            }

            a {
                font-size: 14px;
                font-weight: 500;
                color: rgba(0,0,0,0.95);
                cursor: pointer;
            }
        }
    }
}



`


export default Imprint;